module.exports = __webpack_public_path__ + "static/img/AI.3d10b9e4.svg";